<template>
  <div :class="$style.navigation">
    <navigation
      v-for="item in menu"
      :key="item.slug"
      :slug="item.slug"
      :name="item.name"
      :opened="opened[item.slug]"
      :categories="item.categories"
      @toggle="toggle(item.slug)"
    />
  </div>
</template>

<script>
import { menu } from '@/assets/scripts/menu';
import Navigation from './navigation.vue';

export default {
  components: {
    Navigation,
  },
  data: () => ({
    opened: menu.reduce((acc, item) => {
      acc[item.slug] = true;
      return acc;
    }, {}),
  }),
  computed: {
    menu: () => menu,
  },
  methods: {
    toggle(slug) {
      this.opened[slug] = !this.opened[slug];
    },
  },
};
</script>

<style lang="scss" module>
  .navigation {
    margin-top: 20px;
    width: 250px;
  }
</style>
